import { Video } from "@shared/video";

export const Snapchat = () => (
  <div className="flex flex-col gap-3">
    <p className="mb-0">
      Please create a custom parameter with the following name and value:
    </p>
    <div className="flex flex-col gap-1">
      <p className="mb-0">
        <b>Parameter Name: </b>
        <code>nbt</code>
      </p>
      <p className="mb-0">
        <b>Parameter Value:</b>{" "}
        <code>
          {
            "nb:snapchat:{{site_source_name}}:{{campaign.id}}:{{adSet.id}}:{{ad.id}}"
          }
        </code>
      </p>
    </div>
    <div className="flex flex-col gap-1">
      <p className="font-semibold mb-0">Directions:</p>
      <ul className="list-decimal pl-4 mb-0">
        <li>Navigate to your ad details</li>
        <li>Click "Build a URL Parameter"</li>
        <li>Scroll to "Custom Parameters"</li>
        <li>Insert the Name + Value listed above</li>
        <li>Hit Publish</li>
      </ul>
    </div>
    <Video
      title="Inserting NorthBeam UTMs for Snapchat"
      src="https://www.youtube.com/embed/bnjQpwazReA?rel=0"
    />
  </div>
);
